import api from '@js/actions/api';

export const fetchTags = (filter = {}, options = {}, requestOptions = {}) => (
    api.get('/api/v1/tags', {
        filter,
        ...options
    }, requestOptions)
);
